import { Component, Input, OnInit } from '@angular/core';

import { TeamLogoDto } from '@app/core/logo.model';
import { LogoService } from '@app/core/logo.service';

@Component({
  selector: 'app-sport-team-banner',
  styleUrls: ['./sport-team-banner.component.css'],
  templateUrl: './sport-team-banner.component.html'
})
export class SportTeamBannerComponent implements OnInit {
  teamLogo: TeamLogoDto;
  watermarkImageUrl: string;

  @Input()
  set fleet(value) {
    this._fleet = value;
    this.watermarkImageUrl = this.logoService.getWatermarkImageUrl(value);
    this.getTeamLogo();
  }

  // tslint:disable-next-line: variable-name
  private _fleet: string;

  constructor(private logoService: LogoService) {}

  ngOnInit() {}

  private getTeamLogo() {
    this.logoService.getTeamLogo(this._fleet).then(data => {
      this.teamLogo = data;
    });
  }
}
